import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { isTokenExpired } from "../utilis/auth";

const UserRoute = ({ children }) => {
  const userSession = useSelector((state) => state.user) || {};
  const { token = null, user = null, isLoggedIn = false } = userSession;

  if (!token || !isLoggedIn || isTokenExpired(token)) {
    return <Navigate to="/" replace />;
  }

  if (user?.role !== "user") {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default UserRoute;
